<script setup lang="ts">
import { ButtonColor, ButtonSize, ButtonVariant } from '@/hooks/useButtonClasses';
import { useFormHelpers } from '@/hooks/useFormHelpers';

import AuthForm from '@/components/form/AuthForm.vue';
import FormTextInput from '@/components/formTextInput/FormTextInput.vue';
import FormRows from '@/components/formRows/FormRows.vue';
import StackedFormFooter from '@/components/formFooter/StackedFormFooter.vue';
import Button from '@/components/button/Button.vue';
import AuthFormWrapper from '@/components/auth/AuthFormWrapper.vue';
import Alert from '@/components/alert/Alert.vue';

import Logo from '@/images/cac-logo.svg';
import AbstractTriangle from '@/images/abstract-triangle.svg';

import IconTimesCircle from '@/icons/line/times-circle.svg';

const login = useForm({
  method: 'POST',
  url: route('login.store'),
  fields: {
    email: ''
  }
});

const { isClean } = useFormHelpers(login);
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/domains/auth/layouts/two-columns-guest.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <AuthFormWrapper title="Log in to GRACE">
    <template #header>
      <div class="flex items-center justify-between">
        <div class="flex h-28 w-28 items-center rounded-full bg-slate-100">
          <Logo class="mx-auto h-10" />
        </div>
        <div class="w-[73px]">
          <AbstractTriangle />
        </div>
      </div>
    </template>

    <AuthForm @submit.prevent="login.submit">
      <FormRows>
        <FormTextInput
          label="Email"
          name="email"
          type="email"
          placeholder="e.g. user@example.com"
          autofocus
          :modelValue="login.fields.email"
          :hasError="!!login.errors.email"
          @update:modelValue="(value: any) => (login.fields.email = value)"
        />
      </FormRows>
      <Alert
        v-if="login.hasErrors"
        :icon="IconTimesCircle"
        variant="soft"
        color="danger"
        title="Invalid email"
        :description="login.errors.email"
      />
      <template #footer>
        <StackedFormFooter>
          <Button
            :color="ButtonColor.primary"
            :isDisabled="login.processing || isClean"
            :isLoading="login.processing"
            :size="ButtonSize.lg"
            :variant="ButtonVariant.solid"
            type="submit"
            useMediaQuery
            >Next</Button
          >
        </StackedFormFooter>
      </template>
    </AuthForm>
  </AuthFormWrapper>
</template>
